import { memo } from 'react'
import { ButtonProps as BaseButtonProps } from '@material-ui/core'
import { ButtonWithLoader, LOADER_SIZE, CircularProgress } from './Button.style'

export interface ButtonProps extends BaseButtonProps {
  isLoading?: boolean
  loaderSize?: number
  download?: {
    href: string
    filename: string
  }
}

const Button = ({
  download,
  loaderSize = LOADER_SIZE,
  ...props
}: ButtonProps) => {
  const { isLoading, children, disabled } = props
  return (
    <ButtonWithLoader
      {...props}
      isLoading={isLoading}
      disabled={isLoading || disabled}
    >
      {isLoading && <CircularProgress size={loaderSize} />}
      {download ? (
        <a
          id={`${props.id || 'btn'}-link`}
          download={download.filename}
          href={download.href}
        >
          {children}
        </a>
      ) : (
        <p>{children}</p>
      )}
    </ButtonWithLoader>
  )
}

export default memo(Button)
